/**
 * Legacy renderer for historical processFiles tool parts.
 *
 * New chats no longer use processFiles, but old chats may still contain
 * `tool-processFiles` parts. Generated files from those parts are hoisted by
 * `preview-message.tsx`, so this renderer intentionally does not render output.
 */
export function ProcessFilesTool(_props: { part: unknown; messageUuid: string }) {
  return null;
}
